export default __webpack_public_path__ + "static/sigla_guv_coroana_albastru-eaad2c88c0c3befc4596b0d7dc93ecbe.png";